import { LeaseAgreementCategory } from '../../../rent/model/const/enums';
import { BlockContractService } from '../../../rent/service/data/block-contract.service';
import { CooperativeHousingContractService } from '../../../rent/service/data/cooperative-housing-contract.service';
import { DwellingContractService } from '../../../rent/service/data/dwelling-contract.service';
import { OtherContractService } from '../../../rent/service/data/other-contract.service';
import { ParkingContractService } from '../../../rent/service/data/parking-contract.service';
import { PremisesContractService } from '../../../rent/service/data/premises-contract.service';

/** Base class for lease agreement command handlers */
export abstract class LeaseAgreementCommandHandlerBase {
  constructor(
    private readonly _dwellingService: DwellingContractService,
    private readonly _parkingService: ParkingContractService,
    private readonly _premisesService: PremisesContractService,
    private readonly _otherService: OtherContractService,
    private readonly _blockService: BlockContractService,
    private readonly _cooperativeService: CooperativeHousingContractService
  ) {}

  protected _getService(category: LeaseAgreementCategory) {
    switch (category) {
      case LeaseAgreementCategory.Parking:
        return this._parkingService;
      case LeaseAgreementCategory.Premises:
        return this._premisesService;
      case LeaseAgreementCategory.Dwelling:
        return this._dwellingService;
      case LeaseAgreementCategory.Other:
        return this._otherService;
      case LeaseAgreementCategory.Block:
        return this._blockService;
      case LeaseAgreementCategory.CooperativeHousing:
        return this._cooperativeService;

      default:
        throw new Error(`The specified contract category is not supported. Category: ${category}`);
    }
  }
}
